
import { AfterViewInit, Component, Inject, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Html5Qrcode } from 'html5-qrcode';
@Component({
  selector: 'barcode-scanner',
  templateUrl: './barcode-scanner.component.html'
})

export class BarcodeScannerComponent implements AfterViewInit {
 

  constructor(
    public dialogRef: MatDialogRef<BarcodeScannerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ){}
  ngOnInit(): void {
  }


  
  private html5QrCode!: Html5Qrcode;
  
  ngAfterViewInit(): void {
    this.html5QrCode = new Html5Qrcode('reader',true);
    const qrCodeSuccessCallback = (decodedText: string, decodedResult: any) => {
      this.dialogRef.close(decodedText);
    };
    const qrCodeErrorCallback = (decodedText: string, decodedResult: any) => {
      console.log(decodedText)
    };
    const config = { fps: 10, qrbox: { width: 200, height: 100 } };

  
  // If you want to prefer front camera
//this.html5QrCode.start({ facingMode: "user" }, config, qrCodeSuccessCallback,qrCodeErrorCallback);
    // If you want to prefer back camera
   this.html5QrCode.start({ facingMode: 'environment' }, config, qrCodeSuccessCallback,qrCodeErrorCallback);


  }

  ngOnDestroy(): void {
    if (this.html5QrCode) {
      this.html5QrCode.stop().then(() => {
        this.html5QrCode.clear();
        //this.html5QrCode=null;
      });
    }
  }
}
